import vueInstance from "../main";

export const delegationStatus = Object.freeze({
  STATUS_DELETED: 0,
  STATUS_CREATED: 1,
  STATUS_SUBMITTED: 2,
  STATUS_ACCEPTED: 3,
  STATUS_SETTLED: 4,
  STATUS_REJECTED: 5,
  STATUS_REJECTED_FOR_CORRECT: 6,
  STATUS_CANCELLED: 7
});

export const delegationStatusExtended = function() {
  return [
    //{text: vueInstance.$t('delegationOrder.statusText.deleted'), value: delegationStatus.STATUS_DELETED},
    {
      text: vueInstance.$t("delegation.statusText.created"),
      value: delegationStatus.STATUS_CREATED,
      color: "grey",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegation.statusText.submitted"),
      value: delegationStatus.STATUS_SUBMITTED,
      color: "primary",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegation.statusText.accepted"),
      value: delegationStatus.STATUS_ACCEPTED,
      color: "teal",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegation.statusText.rejected"),
      value: delegationStatus.STATUS_REJECTED,
      color: "red",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegation.statusText.rejectedForCorrect"),
      value: delegationStatus.STATUS_REJECTED_FOR_CORRECT,
      color: "red",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegation.statusText.cancelled"),
      value: delegationStatus.STATUS_CANCELLED,
      color: "warning",
      textColor: "white"
    },
    {
      text: vueInstance.$t("delegation.statusText.settled"),
      value: delegationStatus.STATUS_SETTLED,
      color: "success",
      textColor: "white"
    }
  ];
};
